
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/hebergement",
      function () {
        return require("private-next-pages/[region]/[resort]/hebergement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/hebergement"])
      });
    }
  